import { RECIBO } from '../actions/types';

const initialState = {
    recibo: null
}

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case RECIBO.OBTENER:
            return {
                ...state,
                recibo: payload
            };
        default:
            return state;
    }
}